import {Ng2IzitoastService} from 'ng2-izitoast';
import {Injectable} from '@angular/core';
import {ErrorDictionaryService} from './error-dictionary.service';

@Injectable()
export class NotificationService {
  constructor(private iziToast: Ng2IzitoastService,
              private errorDictionaryService: ErrorDictionaryService) {
  }

  success(title, message) {
    this.iziToast.success({
      title: title,
      message: message,
      rtl: true,
      timeout: 5000,
    });
  }

  warning(title, message) {
    this.iziToast.warning({
      title: title,
      message: message,
      rtl: true,
    });
  }

  error(title, message) {
    this.iziToast.error({
      title: title,
      message: message,
      rtl: true,
    })
    ;
  }

  info(title, message) {
    this.iziToast.info({
      title: title,
      message: message,
      rtl: true,
    });
  }

  showStrcturedError(error): string {
    const ruleId = parseInt(error.message);
    if (!isNaN(ruleId)) {
      return this.errorDictionaryService.get(ruleId);
    } else {
      const errorMessage = this.errorDictionaryService.get(1);
      this.error('خطا', errorMessage);
      return null;
    }
  }
}
